<template>
  <v-app id="app">
    <div v-if="hasNavBarView">
      <v-main :style="{marginTop: safeAreaOffset + 'px'}">
        <v-container>
          <navigation />
          <router-view />
          <show-status-info />
          <loader />
          <chat-bot />
        </v-container>
      </v-main>
    </div>
    <div v-else>
      <v-main :style="{marginTop: safeAreaOffset + 'px'}">
        <v-container>
          <show-status-info />
          <router-view />
          <loader />
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import ChatBot from "@/components/Chatbot/ChatBot";
import Loader from "@/components/Layout/Loader";
import Navigation from "@/components/Layout/Navigation";
import ShowStatusInfo from "@/components/Layout/ShowStatusInfo";
import {mapGetters} from "vuex";
import {loadServerVisibilityOverrides} from "@/config/konekoVisibility";
import {bumpKonekoVisibilityOverrides} from "@/utils/dashboardViewAsSync";

const safeAreaInsets = require("safe-area-insets");
export default {
  name: "App",
  components: {
    ShowStatusInfo,
    Navigation,
    Loader,
    ChatBot,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    hasNavBarView() {
      return (
        this.$route.name !== "Login" &&
        this.$route.name !== "Register" &&
        this.$route.name !== "ForgotPassword" &&
        this.$route.name !== "ResetPassword" &&
        this.$route.name !== "Report"
      );
    },
  },
  mounted() {
    safeAreaInsets.onChange((newInsets) => {
      this.safeAreaOffset = newInsets.top;
    });
    if (this.isAuthenticated) {
      this.refreshKonekoAccessFromServer();
    }
  },
  watch: {
    isAuthenticated(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        this.$router.push({name: "Login"}).catch(() => {});
        return;
      }
      if (newValue === true) {
        this.refreshKonekoAccessFromServer();
      }
      // Only leave guest routes after login — do not yank /koneko-a → Home.
      if (newValue === true && oldValue === false) {
        const guestRoutes = [
          "Login",
          "Register",
          "ForgotPassword",
          "ResetPassword",
        ];
        if (guestRoutes.includes(this.$route.name)) {
          this.$router.push({name: "Home"}).catch(() => {});
        }
      }
    },
  },
  methods: {
    refreshKonekoAccessFromServer() {
      loadServerVisibilityOverrides()
        .then((ok) => {
          if (ok) bumpKonekoVisibilityOverrides();
        })
        .catch(() => {});
    },
  },
  data() {
    return {
      safeAreaOffset: safeAreaInsets.top,
    };
  },
};
</script>
<style>
#app {
  background-color: #333333;
}
</style>
